import React, { FunctionComponent } from 'react';
import { Chat } from 'features/chat/Chat';
import { EventModel } from 'features/events/EventModel';
import { AnimatePresence } from 'framer-motion';
import { setChatVisible } from 'features/chat/chatSlice';
import { useOnceEffect } from 'hooks/useOnceEffect';
import { useDispatch } from 'react-redux';
import { ChatButtonFloating } from 'features/chat/components/ChatButtonFloating';
import { useAppSelector } from 'hooks/redux';

interface EventChatFloatingProps {
  event: EventModel | null;
}

export const EventChatFloating: FunctionComponent<EventChatFloatingProps> = ({
  event
}) => {
  const chatVisible = useAppSelector((state) => state.chat.isVisible);
  const dispatch = useDispatch();

  useOnceEffect(function setChatInvisibleOnLoad() {
    dispatch(setChatVisible(false));
  });

  if (!event || !event.chatEnabled) {
    return null;
  }

  return (
    <>
      <AnimatePresence initial={false}>
        {chatVisible && (
          <div className="tw-bg-white tw-rounded-xl tw-fixed tw-w-[40%] tw-bottom-4 tw-right-4 tw-top-4 tw-z-50 [&>div]:tw-h-full">
            <Chat fetchHistory={true} />
          </div>
        )}
      </AnimatePresence>
      <ChatButtonFloating />
    </>
  );
};
